import { Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutProcessCommissionsExceptionTable extends Layout {
    tableExceptions: Table;
}
